import styled from 'styled-components';

export const WidgetContainer = styled.div`
  width: 100%;
  height: 100%;
  display: ${props => (props.isWidgetActiveTab ? 'block' : 'none')};
`
